var BufferView = require('bufferview');


var ChildView = BufferView.extend({
    initialize: function (options) {
        this.model.bind('change:archived', this.renderArchived, this);
                
        BufferView.prototype.initialize.apply(this, arguments);
    },
    render: function () {
        BufferView.prototype.render.apply(this, arguments);
        
        this.renderArchived();
        
        this.renderHideJoinPart(true);
        this.renderCollapseJoinPart(true);
        this.renderCollapseReplies(true);
        this.renderQuoteReplies(true);
        // Use wrapper functions so the event args aren't passed along
        this.model.bind('prefChange:hideJoinPart', function () {
            this.renderHideJoinPart();
        }, this);
        this.model.bind('prefChange:expandJoinPart', function () {
            this.renderCollapseJoinPart();
        }, this);
        this.model.bind('prefChange:reply-collapse', function () {
            this.renderCollapseReplies();
        }, this);
        this.listenTo(this.model.connection, 'prefChange:reply-collapse', function () {
            this.renderCollapseReplies();
        });
        this.model.bind('prefChange:reply-quote', function () {
            this.renderQuoteReplies();
        }, this);
        this.listenTo(this.model.connection, 'prefChange:reply-quote', function () {
            this.renderQuoteReplies();
        });
        
        return this;
    },
    renderHideJoinPart: function (initial) {
        $(this.el).toggleClass('hideJoinPart', !this.model.isShowingJoinPart());
        if (!initial) {
            this.scroll.onChange();
        }
        return this;
    },
    renderCollapseJoinPart: function (initial) {
        $(this.el).toggleClass('expandJoinPart', !this.model.isCollapsingJoinPart());
        if (!initial) {
            this.scroll.onChange();
        }
        return this;
    },
    renderCollapseReplies: function (initial) {
        $(this.el).toggleClass('replyCollapse', this.model.isCollapsingReplies());
        if (!initial) {
            this.scroll.onChange();
        }
        return this;
    },
    renderQuoteReplies: function (initial) {
        $(this.el).toggleClass('replyQuote', this.model.isShowingQuoteReplies());
        if (!initial) {
            this.scroll.onChange();
        }
        return this;
    },
    renderArchived: function () {
        $(this.el).toggleClass('archived', this.model.isArchived());
        this.mainTopChange();
        return this;
    }
});


module.exports = ChildView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/childview.js
// module id = plGQ
// module chunks = 1